import { Circle, Hexagon, X } from 'lucide-react';

import { Button } from '@/components/ui/button';

import type { DrawMode } from './GeofenceMap';

const HINTS: Record<DrawMode, string> = {
  polygon: 'Cliquez pour placer les points, double-cliquez pour terminer',
  circle: 'Cliquez le centre, déplacez la souris puis cliquez pour fixer le rayon',
};

interface Props {
  drawMode: DrawMode | null;
  disabled: boolean;
  onStart: (mode: DrawMode) => void;
  onCancel: () => void;
}

export function DrawToolbar({ drawMode, disabled, onStart, onCancel }: Props) {
  if (drawMode) {
    return (
      <div role="toolbar" aria-label="Dessin en cours" className="flex flex-wrap items-center gap-2 rounded-md bg-card/95 border shadow p-2">
        <span className="text-sm">{HINTS[drawMode]}</span>
        <Button size="sm" variant="outline" onClick={onCancel}>
          <X className="h-4 w-4 mr-1" aria-hidden />
          Annuler
        </Button>
      </div>
    );
  }
  return (
    <div role="toolbar" aria-label="Outils de dessin" className="flex flex-wrap gap-2 rounded-md bg-card/95 border shadow p-2">
      <Button size="sm" disabled={disabled} onClick={() => onStart('polygon')}>
        <Hexagon className="h-4 w-4 mr-1" aria-hidden />
        Dessiner polygone
      </Button>
      <Button size="sm" disabled={disabled} onClick={() => onStart('circle')}>
        <Circle className="h-4 w-4 mr-1" aria-hidden />
        Dessiner cercle
      </Button>
    </div>
  );
}
